<svg
  class="icon-arrow"
  [style.transform]="rotate"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 14 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.41091 1.07709C6.73634 0.751649 7.26398 0.751649 7.58942 1.07709L13.4228 6.91042C13.7482 7.23586 13.7482 7.76349 13.4228 8.08893L7.58942 13.9223C7.26398 14.2477 6.73634 14.2477 6.41091 13.9223C6.08547 13.5968 6.08547 13.0692 6.41091 12.7438L10.8217 8.33301H1.16683C0.706592 8.33301 0.333496 7.95991 0.333496 7.49967C0.333496 7.03944 0.706592 6.66634 1.16683 6.66634H10.8217L6.41091 2.2556C6.08547 1.93016 6.08547 1.40252 6.41091 1.07709Z"
    [attr.fill]="color"
  />
</svg>
